import { DEFAULT_PAGE_SIZE } from '@client/app/shared-modules/api/constants/page-size.constant';
import { DEFAULT_PAGE } from '@client/app/shared-modules/api/constants/page.constant';

export const paginationUrlQueryParamsDeclarations = () => {
    return {
        page_size: {
            dynamic: true,
            value: DEFAULT_PAGE_SIZE.toString(),
        },
        page: {
            dynamic: true,
            value: DEFAULT_PAGE.toString(),
        },
    };
};
